module.exports = __webpack_public_path__ + "static/img/xinyong.30a340ea.png";